/*
 * @Description:
 * @Author: fiveonelei
 * @Date: 2022-03-31 16:29:57
 * @FilePath: /vise/packages/app-share/src/composable/use-request-data-method/fetch-share-strategy.ts
 */
import useProvideUrlInfo from '@/composable/use-provide-url-info';
import useProvideCookieInfo from '@/composable/use-provide-cookie-info';
import useGetCommonMethods from '@/composable/use-get-common-method';
import fetchShareStrategy from '@/services/fetch-share-strategy';

type FetchReq = {
  isWsInstalled: boolean,
};

export default function useShareStrategyMethod() {
  const { info: urlInfo } = useProvideUrlInfo();
  const { info: cookieInfo } = useProvideCookieInfo();
  const { getGrowthTestScene } = useGetCommonMethods();

  return (params: FetchReq) => {
    const { collectionid = '', spid = '', id = '' } = urlInfo.query;
    return fetchShareStrategy({
      uniqueID: cookieInfo.openid || cookieInfo.silent_openid,
      uin: cookieInfo.uin,
      scene: getGrowthTestScene(),
      isWsInstalled: params.isWsInstalled,
      pageType: !!collectionid ? 2 : 1, // 页面类型 0:其他 1:普通播放 2:合集页 3:完播页
      feedID: id,
      collectionID: collectionid,
      SharerID: spid,
    });
  };
}
